<template>
  <div >
      <i class="el-icon-s-fold" @click="ShowNav"></i>
      <i class="login-out" @click="logout">
        <i class="el-icon-switch-button login-out-icon"></i>
        退出
      </i>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props : {
        isCollapse : {
            type : Boolean,
            default : () => false
        },
    },
    data(){
      return{
      }
    },
    computed: {
    },
    created(){
    },
    methods: {
      logout() {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      },
      ShowNav(){
          this.$emit("ShowNav");
      }
    }
  }
</script>
<style>
.sys-tit{
  float:left;
  font-size:22px;
  color:#fff;
  font-weight:normal;
}
  
  .el-aside {
    color: #333;
  }
  .login-out {
    cursor: pointer;
  }
  .el-icon-s-fold{
    /* display: inline-block; */
    /* position: relative; */
    padding-left: 0px;
    color: #1b5bff;
    font-size: 30px;
    /* font-style: normal; */
    /* height: 30px; */
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue